<template>
  <section class="content">
    <div class="box">
      <div class="box-header with-border">
        <h3 class="box-title">Payment records</h3>
      </div>
      <div class="box-body">
        <v-data-table :headers="headers" :items="records" class="elevation-1" data-app>
          <template v-slot:items="props">
            <td>{{ props.item.client.name }}</td>
            <td>{{ props.item.campaign.name }}</td>
            <td>{{ props.item.amount }}</td>
            <td>{{ props.item.status == 1 ? 'Approved' : 'Submitted' }}</td>
            <td>{{ props.item.createdAt | formatTime }}</td>
            <td>
              <v-btn
                @click="showModalEdit(props.item)"
                data-toggle="tooltip"
                data-placement="top"
                title="View Payment Detail"
                color="info"
                class="ims-action"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>No Payment Records found!</template>
        </v-data-table>
      </div>
      <v-dialog
        v-model="viewPaymentDetailDialog"
        v-if="selectedRecord && selectedRecord.id"
        persistent
        max-width="600px"
      >
        <v-card>
          <form>
            <v-card-title>
              <span class="headline">Payment Record Details</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout column wrap>
                  <v-layout row justify-space-between>
                    <v-flex xs12 sm6 md4>
                      <p class="title">Client</p>
                      <p class="subtitle-1">{{ selectedRecord.client.name }}</p>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <p class="title">Campaign</p>
                      <p class="subtitle-1">{{ selectedRecord.campaign.name }}</p>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      :items="paymentStatus"
                      item-text="text"
                      item-value="value"
                      label="Status"
                      v-model="selectedRecord.status"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Amount"
                      type="number"
                      hint="Insert the amount you need to submit (SGD)"
                      required
                      v-model="selectedRecord.amount"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4 v-if="selectedRecord.image">
                    <p class="title">Receipt/Proof</p>
                    <div class="text-xs-center">
                      <a :href="selectedRecord.image.Location" target="_blank">
                        <img :src="selectedRecord.image.Location" height="250" width="auto">
                      </a>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6 md4></v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="red" @click="deleteRecord" dark small>
                Delete this Record
                <v-icon>delete</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn dark color="blue darken-1" @click="viewPaymentDetailDialog = false">Close</v-btn>
              <v-btn dark color="blue darken-1" @click="updateRecord">Save</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import moment from 'moment';
import api from '@/api';

export default {
  data() {
    return {
      totalRow: 0,
      perPage: 10,
      records: [],
      selectedRecord: null,
      headers: [
        {
          text: 'Client',
          value: 'name'
        },
        {
          text: 'Campaign',
          value: 'name'
        },
        {
          text: 'Amount',
          value: 'amount'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Time',
          value: 'name'
        },
        {
          text: 'Actions'
        }
      ],
      paymentStatus: [
        {
          text: 'Submitted',
          value: 0
        },
        {
          text: 'Approve',
          value: 1
        }
      ],
      viewPaymentDetailDialog: false
    };
  },
  created() {
    this.fetchPaymentRecords();
  },
  filters: {
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss');
    }
  },
  methods: {
    fetchPaymentRecords() {
      api
        .request('get', `/api/v1/clients/payment-records?page=${this.currentPage}&per_page=${this.perPage}`, true)
        .then(response => {
          if (response.data.records) {
            this.records = response.data.records;
            this.totalRow = response.data.totalRecords;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    showModalEdit(record) {
      this.selectedRecord = record;
      this.viewPaymentDetailDialog = true;
    },
    deleteRecord() {
      this.$swal({
        title: 'Are You Sure?',
        text: 'This task cannot be undone.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I understand'
      }).then(result => {
        if (result.value) {
          api
            .request('delete', `/api/v1/clients/payment-records/${this.selectedRecord.id}`, true)
            .then(response => {
              this.viewPaymentDetailDialog = false;
              this.selectedRecord = null;
              this.fetchPaymentRecords();
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          // Do nothing
        }
      });
    },
    updateRecord() {
      api
        .request('post', `/api/v1/clients/payment-records/${this.selectedRecord.id}`, true, {
          amount: this.selectedRecord.amount,
          status: this.selectedRecord.status
        })
        .then(response => {
          this.viewPaymentDetailDialog = false;
          this.fetchPaymentRecords();
          this.selectedRecord = null;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// AdminPayment.vue?79ba2b56